import { FunctionComponent } from 'react';
import { TextField, Typography } from '@mui/material';
import useWindowDimensions from '../hooks/dimension';

interface TFWithLabelAndLinkProps {
    title?: string | '';
    label?: string | '';
    link?: string | '';
    labelPlaceholder?: string | '';
    linkPlaceholder?: string | '';
    onChange?: any;
    id?: number;
}

const TFWithLabelAndLink: FunctionComponent<TFWithLabelAndLinkProps> = ({ title, label, link, labelPlaceholder, linkPlaceholder, onChange, id }) => {

    const { height, width } = useWindowDimensions();

    return (
        <div className={width && width > 600 ? 'inline-start' : 'column'}>
            <Typography variant='body1' style={{ marginBottom: 8 }}>{title}</Typography>
            <TextField id='outlined-basic' placeholder={labelPlaceholder} variant='standard' size='small' style={{
                marginBottom: 8,
                marginLeft: 8,
                display: 'flex',
                flex: 2,
            }}
                InputProps={{
                    disableUnderline: true
                }}
                value={label}
                onChange={(e) => onChange(id, 'value', e.target.value)}
            />
            <div>
                <TextField id='outlined-basic' placeholder={linkPlaceholder} variant='standard' size='small' style={{
                    marginLeft: 8,
                    marginBottom: width && width < 600 ? 12 : 8, marginTop: width && width < 600 ? -8 : 0,
                    display: 'flex',
                }}
                    InputProps={{
                        disableUnderline: true
                    }}
                    value={link}
                    onChange={(e) => onChange(id, 'link', e.target.value)}
                />
            </div>
        </div>
    );
}

export default TFWithLabelAndLink;